;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { KlantenPhone } from './mobile/klanten-phone'
import { PlanningPhone } from './mobile/planning-phone'
import { UrenPhone } from './mobile/uren-phone'

/**
 * The Offsoo app on a phone, in three screens: the month board, logging hours, and a client file.
 *
 * Each screen is its own file under `mobile/` — they share only the phone's furniture (status bar,
 * tab bar, icons) in `mobile/chrome.tsx`, and the CSS module beside this one.
 */
export function MobileVisual({
  className,
  variant = 'planning',
}: {
  className?: string
  variant?: 'planning' | 'uren' | 'klanten'
}) {
  if (variant === 'uren') return <UrenPhone className={className} />
  if (variant === 'klanten') return <KlantenPhone className={className} />
  return <PlanningPhone className={className} data-sentry-element="PlanningPhone" data-sentry-component="MobileVisual" data-sentry-source-file="mobile-visual.tsx" />
}
